<div class="row wrapper border-bottom white-bg page-heading info-projeto">
  <div class="col-lg-10 title-projeto">
    <h2>{{projeto?.title}}</h2>
  </div>
  <div class="row" *ngIf="this.projeto">
    <div class="col-lg-12">
      <div class="title">
        Órgão responsável <span class="content">{{projeto?.agency?.name}}</span>
      </div>
      <div class="title">
        Gerente <span class="content">{{projeto?.manager?.name}}</span>
      </div>
    </div>
  </div>

  <div class="col-lg-10">
    <h2>{{type ? 'Programa' : 'Projeto Agregador'}}</h2>
  </div>
</div>

<div class="wrapper wrapper-content animated fadeInRight">
  <div class="row">
    <div class="col-lg-12">
      <div class="ibox float-e-margins">

        <div class="ibox-content box-content">
          <div>
            <div class="btn-list">
              <div class="blocked" *ngIf="indicador?.can_full_block || indicador?.can_meta_block">
                <div class="full" (click)="bloqueioIndicadorProjeto(true)" *ngIf="indicador?.can_full_block" tooltip="Bloqueio Total" placement="bottom">
                  <img src="assets/images/svgs/Bloquear-total.svg" alt="Bloqueio Total" *ngIf="indicador?.full_blocked">
                  <img src="assets/images/svgs/Desbloquear-total.svg" alt="Desbloqueio Total" *ngIf="!indicador?.full_blocked">
                </div>
                <div class="meta" (click)="bloqueioIndicadorProjeto()" *ngIf="indicador?.can_meta_block" tooltip="Bloqueio Meta" placement="bottom">
                  <img src="assets/images/svgs/Bloquear-meta.svg" alt="Bloqueio Meta" *ngIf="indicador?.meta_blocked">
                  <img src="assets/images/svgs/Desbloquear-meta.svg" alt="Desbloqueio Meta" *ngIf="!indicador?.meta_blocked">
                </div>
              </div>
              <div class="btn-icon">
                <img src="assets/images/svgs/Imprimir.svg" alt="Imprimir"(click)="openPrintModal()" tooltip="Imprimir" placement="bottom">
              </div>
              <div class="btn-icon">
                <img src="assets/images/svgs/Editar.svg" [alt]="indicador?.readonly ? 'Ver' : 'Editar'" *ngIf="indicador?.edit" (click)="editar()" tooltip="Editar" placement="bottom">
              </div>
              <button type="button" class="btn-back" (click)="voltar()">Voltar</button>
            </div>

            <div class="info-page">
              <h3>Indicador {{ indicador?.code }} - {{ indicador?.title }}</h3>
            </div>

            <div class="list-info">
              <h4>Unidade de medida:</h4>
              <p>{{ indicador?.unit_id }}</p>
            </div>

            <div class="list-info">
              <h4>Responsável pela análise:</h4>
              <p>{{ indicador?.resp_nome }}</p>
            </div>

            <div class="list-info">
              <h4>Meta Global:</h4>
              <p>{{ indicador?.goal }}</p>
            </div>

            <div class="list-info">
              <h4>Periodicidade da medição:</h4>
              <p>{{ indicador?.period_mod }}</p>
            </div>

            <div class="list-info">
              <h4>Polaridade:</h4>
              <p>{{ indicador?.polarity }}</p>
            </div>

            <div class="list-info">
              <h4>Valores:</h4>
              <p>{{ indicador?.accum }}</p>
            </div>
          </div>

          <div class="container_component" *ngIf="indicador?.can_see_table">
            <app-detalhe-pg-indicadores-meta-realizado [indicador]="indicador"></app-detalhe-pg-indicadores-meta-realizado>
          </div>

          <div class="container_component" *ngIf="indicador?.can_see_analysis">
            <app-detalhe-projeto-indicadores-analise-list [type]="type" [idPgIndicador]="indicador?.id"></app-detalhe-projeto-indicadores-analise-list>
          </div>

          <div class="container_component" *ngIf="indicador?.can_see_critical">
            <app-detalhe-projeto-pontos-criticos-list [pgType]="type" [idPgIndicador]="indicador?.id"></app-detalhe-projeto-pontos-criticos-list>
          </div>

          <div class="container_component" *ngIf="indicador?.can_see_action">
            <app-detalhe-projeto-plano-acao-list [type]="type" [isProjeto]="false" [idPgIndicador]="indicador?.id"></app-detalhe-projeto-plano-acao-list>
          </div>

          <div class="container_component" *ngIf="indicador?.can_see_doc">
            <app-detalhe-documento-list [isProjeto]="false" [idPgIndicador]="indicador?.id"></app-detalhe-documento-list>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #modalPrint>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Impressão de Relatório</h4>
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="closePrintModal()">
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>
  <div class="modal-body table-form">

    <div class="form-group row m-b">
      <div class="col-sm-12">
        <label class="col-sm-12 pb-1">Anos</label>
        <ng-select id="years" class="ng-select-alternative" [items]="indicador?.years" [(ngModel)]="infoImprimir.years" [multiple]="true" placeholder="Todos">
        </ng-select>
      </div>
    </div>

    <div class="form-group row m-b">
      <div class="col-sm-12">
        <div class="form-group row">
          <div class="switch col-2">
            <div class="onoffswitch">
              <input type="checkbox" (change)="infoImprimir.analise = !infoImprimir?.analise" [checked]="infoImprimir?.analise" class="onoffswitch-checkbox" id="analise">
              <label class="onoffswitch-label" for="analise">
                <span class="onoffswitch-inner switchCheck"></span>
                <span class="onoffswitch-switch"></span>
              </label>
            </div>
          </div>
          <label class="label-switch" for="analise">Análise</label>
        </div>
      </div>
    </div>

    <div class="form-group row m-b">
      <div class="col-sm-12">
        <div class="form-group row">
          <div class="switch col-2">
            <div class="onoffswitch">
              <input type="checkbox" (change)="infoImprimir.ponto = !infoImprimir?.ponto" [checked]="infoImprimir?.ponto" class="onoffswitch-checkbox" id="ponto">
              <label class="onoffswitch-label" for="ponto">
                <span class="onoffswitch-inner switchCheck"></span>
                <span class="onoffswitch-switch"></span>
              </label>
            </div>
          </div>
          <label class="label-switch" for="ponto">Pontos Críticos</label>
        </div>
      </div>
    </div>

    <div class="form-group row m-b">
      <div class="col-sm-12">
        <div class="form-group row">
          <div class="switch col-2">
            <div class="onoffswitch">
              <input type="checkbox" (change)="infoImprimir.plano = !infoImprimir?.plano" [checked]="infoImprimir?.plano" class="onoffswitch-checkbox" id="plano">
              <label class="onoffswitch-label" for="plano">
                <span class="onoffswitch-inner switchCheck"></span>
                <span class="onoffswitch-switch"></span>
              </label>
            </div>
          </div>
          <label class="label-switch" for="plano">Plano de Ação</label>
        </div>
      </div>
    </div>
    <div class="hr-line-dashed"></div>
    <div class="form-group row d-flex justify-content-end">
      <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
        <button class="btn btn-white m-r-xs" type="button" (click)="closePrintModal()">Fechar</button>
        <button class="btn btn-primary" type="button" (click)="imprimir()">Imprimir</button>
      </div>
    </div>
  </div>
</ng-template>

<app-loading [loader]="isLoading"></app-loading>